import React, { createContext, useContext, useState } from "react";
import CommonMessageModal from "../components/CommonMessageModal";

// Allowed types
const MESSAGE_TYPES = ["success", "warning", "error"];

const MessageContext = createContext();

export const MessageProvider = ({ children }) => {
  const [msg, setMsg] = useState({
    isOpen: false,
    type: "success",
    title: "",
    message: "",
    action: null
  });

  // Show message
  const showMessage = ({
    type = "success",
    title = "",
    message = "",
    action = null
  }) => {
    if (!MESSAGE_TYPES.includes(type)) {
      console.warn(`Invalid message type "${type}". Defaulting to "success".`);
      type = "success";
    }
    setMsg({ isOpen: true, type, title, message, action });
  };

  // Close message and reset state
  const closeMessage = () => {
    setMsg({
      isOpen: false,
      type: "success",
      title: "",
      message: "",
      action: null
    });
  };

  // Prepare the confirm handler
  const onConfirm = msg.action
    ? () => msg.action({ close: closeMessage })
    : null;

  return (
    <MessageContext.Provider value={{ showMessage }}>
      {children}
      <CommonMessageModal
        isOpen={msg.isOpen}
        type={msg.type}
        title={msg.title}
        message={msg.message}
        onClose={closeMessage}
        onConfirm={onConfirm}
      />
    </MessageContext.Provider>
  );
};

export const useMessage = () => useContext(MessageContext);
